module.exports = __webpack_public_path__ + "static/media/office3.edb5886c.jpg";